export const END_OF_LIFE_CHART = "end_of_life";
export const ASSET_AGE_CHART = "age";

export const CHART_CATEGORY_CONFIG = {
    [END_OF_LIFE_CHART]: {
        heading: "End of Service Life Categories",
        rangeLabel: "Years Remaining",
        resolvesToYears: true
    },
    [ASSET_AGE_CHART]: {
        heading: "Age Categories",
        rangeLabel: "Years Elapsed"
    }
};

export const NEW_CATEGORY_COLORS = ["#1382d9", "#4e9e6a", "#d8c24a", "#e0a052", "#c03a35", "#7a5ea8", "#3f8fa8", "#b05a97"];

export const PRESET_COLORS = ["#95cd50", "#ffe242", "#ffa105", "#ff0305", "#525252", "#343C65", "#8B572A", "#417505"];

export const GET_CHART_CATEGORIES_REQUEST = "GET_CHART_CATEGORIES_REQUEST";
export const GET_CHART_CATEGORIES_SUCCESS = "GET_CHART_CATEGORIES_SUCCESS";
export const GET_CHART_CATEGORIES_FAILURE = "GET_CHART_CATEGORIES_FAILURE";

export const SAVE_CHART_CATEGORIES_REQUEST = "SAVE_CHART_CATEGORIES_REQUEST";
export const SAVE_CHART_CATEGORIES_SUCCESS = "SAVE_CHART_CATEGORIES_SUCCESS";
export const SAVE_CHART_CATEGORIES_FAILURE = "SAVE_CHART_CATEGORIES_FAILURE";
